import type { TankType } from './AddStation'

export const getTankNamesError = (tanks: TankType[]): string | null => {
  const namedTankCount = tanks.filter((tank) => Boolean(tank.name?.trim())).length
  return namedTankCount > 0 && namedTankCount < tanks.length ? 'Name every tank, or none.' : null
}

export const tanksToSave = (tanks: TankType[]): TankType[] =>
  tanks.map(({ name, ...tank }) => {
    const trimmedName = name?.trim()
    return trimmedName ? { ...tank, name: trimmedName } : tank
  })
